import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import type { Brand } from '../../types/brand';

interface BrandSelectorProps {
  brands: Brand[];
  selectedBrand: Brand | null;
  onSelectBrand: (brand: Brand) => void;
  onCreateNew: () => void;
}

export function BrandSelector({
  brands,
  selectedBrand,
  onSelectBrand,
  onCreateNew
}: BrandSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 bg-gray-800 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
      >
        <span>{selectedBrand?.name || 'Select Brand'}</span>
        <ChevronDown className="w-4 h-4" />
      </button>

      {isOpen && (
        <div 
          className="absolute top-full left-0 mt-2 w-56 rounded-md shadow-lg bg-gray-800 ring-1 ring-black ring-opacity-5 z-50"
          onMouseLeave={() => setIsOpen(false)}
        >
          <div className="py-1">
            {brands.map(brand => (
              <button
                key={brand.id}
                onClick={() => {
                  onSelectBrand(brand);
                  setIsOpen(false);
                }}
                className={`block w-full text-left px-4 py-2 text-sm ${
                  selectedBrand?.id === brand.id
                    ? 'bg-gray-700 text-white'
                    : 'text-gray-300 hover:bg-gray-700'
                }`}
              >
                {brand.name}
              </button>
            ))}
            
            <div className="border-t border-gray-700 mt-1 pt-1">
              <button
                onClick={() => {
                  onCreateNew();
                  setIsOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-sm text-gray-300 hover:bg-gray-700"
              >
                Create New Brand
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 